<div class="px-5 pt-5 pb-4 bg-white">
  <div class="flex items-start gap-3">
    <div
      class="flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl ring-1"
      [ngClass]="headingIconWrapClass"
    >
      <lucide-icon
        [name]="headingIcon"
        class="h-5 w-5"
        [class.animate-spin]="isRunning && !isPausing"
      ></lucide-icon>
    </div>
    <div class="min-w-0 pt-0.5">
      <h2 class="text-base font-semibold leading-tight text-gray-900">{{ title }}</h2>
      <p class="mt-1 text-[11px] leading-relaxed text-gray-500">{{ message }}</p>
    </div>
  </div>

  <div *ngIf="isRunning" class="mt-4 rounded-xl bg-sky-50/70 px-3 py-3 ring-1 ring-sky-100">
    <div class="flex items-end justify-between gap-3">
      <div>
        <div class="text-[11px] font-medium uppercase tracking-wide text-sky-800/70">
          Remaining
        </div>
        <div class="text-2xl font-semibold leading-none text-sky-900">
          {{ progress.remaining }}
        </div>
      </div>
      <div class="text-right text-sm font-semibold tabular-nums text-sky-800">
        {{ displayPercent }}%
      </div>
    </div>

    <div class="mt-3 flex h-3 w-full overflow-hidden rounded-full bg-sky-100/90">
      <div
        class="h-full bg-green-500 transition-all duration-300 ease-out"
        [class.animate-pulse]="syncedPercent > 0"
        [style.width.%]="syncedPercent"
      ></div>
      <div
        class="h-full bg-red-400 transition-all duration-300 ease-out"
        [class.animate-pulse]="failedPercent > 0"
        [style.width.%]="failedPercent"
      ></div>
    </div>
    <p class="mt-1.5 text-right text-[11px] font-medium text-sky-800/70">
      {{ progress.synced + progress.failed }} / {{ progress.total }}
    </p>
  </div>

  <div *ngIf="!isRunning" class="mt-4 grid grid-cols-3 gap-2">
    <div class="rounded-lg bg-gray-50 px-2 py-3 text-center ring-1 ring-gray-200/70">
      <div class="text-[11px] font-medium uppercase tracking-wide text-gray-500">Synced</div>
      <div class="mt-1 text-xl font-semibold text-green-700">{{ progress.synced }}</div>
    </div>
    <div class="rounded-lg bg-gray-50 px-2 py-3 text-center ring-1 ring-gray-200/70">
      <div class="text-[11px] font-medium uppercase tracking-wide text-gray-500">Failed</div>
      <div class="mt-1 text-xl font-semibold text-red-700">{{ progress.failed }}</div>
    </div>
    <div class="rounded-lg bg-gray-50 px-2 py-3 text-center ring-1 ring-gray-200/70">
      <div class="text-[11px] font-medium uppercase tracking-wide text-gray-500">Remaining</div>
      <div class="mt-1 text-xl font-semibold text-amber-700">{{ progress.remaining }}</div>
    </div>
  </div>

  <div class="mt-5 flex justify-end gap-2">
    <button
      *ngIf="isRunning"
      type="button"
      class="inline-flex items-center justify-center rounded-lg border border-gray-300 bg-white px-5 py-2 text-sm font-semibold text-gray-800 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-400 disabled:cursor-not-allowed disabled:opacity-60"
      [disabled]="isPausing"
      (click)="onPause()"
    >
      {{ isPausing ? 'Pausing...' : 'Pause' }}
    </button>
    <button
      *ngIf="!isRunning"
      type="button"
      class="inline-flex items-center justify-center rounded-lg bg-blue-600 px-5 py-2 text-sm font-semibold text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      (click)="onClose()"
    >
      OK
    </button>
  </div>
</div>
